import type { ReactNode } from "react"
import type { StorageFile } from "@/schema"

import type { useStoragePickerPages } from "@/hooks/api/storage/pages"

import { StorageRequestError } from "./storage-request-error"
import { VirtualStorageList } from "./virtual-storage-list"

export function StoragePageList({
  page,
  children,
  height = 300,
  scrollToKey,
  pinnedKeys,
  isItemFocusable,
}: {
  page: ReturnType<typeof useStoragePickerPages>
  children: (file: StorageFile) => ReactNode
  height?: number
  scrollToKey?: string
  pinnedKeys?: string[]
  isItemFocusable?: (file: StorageFile) => boolean
}) {
  const status = page.error ? (
    <StorageRequestError error={page.error} retry={page.retry} errorUpdatedAt={page.errorUpdatedAt} />
  ) : page.isLoading || page.hasNextPage ? (
    <div className="text-muted-foreground flex h-10 items-center p-2 text-sm">Loading…</div>
  ) : !page.files.length ? (
    <div className="text-muted-foreground flex h-10 items-center p-2 text-sm">No files found</div>
  ) : undefined
  return (
    <VirtualStorageList
      items={page.files}
      isItemFocusable={isItemFocusable}
      itemKey={(file) => file.id}
      height={height}
      footer={status}
      onEndReached={page.error ? undefined : page.loadMore}
      scrollToKey={scrollToKey}
      pinnedKeys={pinnedKeys}
    >
      {children}
    </VirtualStorageList>
  )
}
